// Savia Product Gallery - Simple and Reliable Implementation
(function() {
  'use strict';
  
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Initializing Savia product gallery...');
    
    // Initialize thumbnail gallery
    initializeThumbnailGallery();
    
    // Initialize mobile swipe
    initializeMobileSwipe();
    
    function initializeThumbnailGallery() {
      const thumbnails = document.querySelectorAll('.thumbnail-item');
      const mainImg = document.getElementById('main-product-img');
      
      console.log('Found thumbnails:', thumbnails.length);
      console.log('Found main image:', !!mainImg);
      
      if (!mainImg || thumbnails.length === 0) {
        console.log('Missing main image or thumbnails');
        return;
      }
      
      // Add click/touch handlers to thumbnails
      thumbnails.forEach((thumbnail, index) => {
        console.log('Setting up thumbnail:', index);
        
        // Click handler
        thumbnail.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Thumbnail clicked:', index);
          selectThumbnail(this, index);
        });
        
        // Touch handler for mobile
        thumbnail.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Thumbnail touched:', index);
          selectThumbnail(this, index);
        });
        
        // Keyboard support
        thumbnail.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectThumbnail(this, index);
          }
        });
        
        // Add tabindex for keyboard navigation
        thumbnail.setAttribute('tabindex', '0');
      });
      
      function selectThumbnail(thumbnailElement, index) {
        const imageUrl = thumbnailElement.dataset.imageUrl;
        
        if (!imageUrl) {
          console.log('No image URL found on thumbnail');
          return;
        }
        
        console.log('Updating main image to:', imageUrl);
        
        // Update main image
        mainImg.src = imageUrl;
        
        // Update active states
        thumbnails.forEach(t => t.classList.remove('active'));
        thumbnailElement.classList.add('active');
        
        // Visual feedback
        thumbnailElement.style.transform = 'scale(0.95)';
        setTimeout(() => {
          thumbnailElement.style.transform = '';
        }, 150);
      }
    }
    
    function initializeMobileSwipe() {
      const imageContainer = document.querySelector('.product-zoom-container');
      const mainImg = document.getElementById('main-product-img');
      const thumbnails = document.querySelectorAll('.thumbnail-item');
      
      console.log('Initializing mobile swipe...');
      console.log('Container:', !!imageContainer);
      console.log('Main image:', !!mainImg);
      console.log('Thumbnails:', thumbnails.length);
      
      if (!imageContainer || !mainImg || thumbnails.length <= 1) {
        console.log('Mobile swipe not initialized - missing elements or only one image');
        return;
      }
      
      let currentIndex = 0;
      let startX = 0;
      let startY = 0;
      let isDragging = false;
      
      // Get all image URLs
      const imageUrls = Array.from(thumbnails).map(thumb => thumb.dataset.imageUrl);
      console.log('Image URLs:', imageUrls);
      
      // Find current index based on active thumbnail
      const activeThumb = document.querySelector('.thumbnail-item.active');
      if (activeThumb) {
        currentIndex = Array.from(thumbnails).indexOf(activeThumb);
      }
      
      // Touch start
      imageContainer.addEventListener('touchstart', function(e) {
        if (e.touches.length !== 1) return;
        
        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        isDragging = false;
        
        console.log('Touch start at:', startX, startY);
      }, { passive: true });
      
      // Touch move
      imageContainer.addEventListener('touchmove', function(e) {
        if (e.touches.length !== 1) return;
        
        const touch = e.touches[0];
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;
        
        // Only handle horizontal swipes
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 15) {
          isDragging = true;
          e.preventDefault(); // Prevent scrolling
          console.log('Horizontal drag detected:', deltaX);
        }
      }, { passive: false });
      
      // Touch end
      imageContainer.addEventListener('touchend', function(e) {
        if (!isDragging) return;
        
        const touch = e.changedTouches[0];
        const deltaX = touch.clientX - startX;
        const threshold = 50;
        
        console.log('Touch end. Delta X:', deltaX, 'Current index:', currentIndex);
        
        if (Math.abs(deltaX) > threshold) {
          if (deltaX > 0 && currentIndex > 0) {
            // Swipe right - previous image
            currentIndex--;
            console.log('Swiping to previous image:', currentIndex);
            updateImage();
          } else if (deltaX < 0 && currentIndex < imageUrls.length - 1) {
            // Swipe left - next image
            currentIndex++;
            console.log('Swiping to next image:', currentIndex);
            updateImage();
          }
        }
        
        isDragging = false;
      }, { passive: true });
      
      function updateImage() {
        const newImageUrl = imageUrls[currentIndex];
        
        if (!newImageUrl) {
          console.log('No image URL for index:', currentIndex);
          return;
        }
        
        console.log('Updating to image index:', currentIndex, 'URL:', newImageUrl);
        
        // Update main image
        mainImg.src = newImageUrl;
        
        // Update active thumbnail
        thumbnails.forEach((thumb, index) => {
          thumb.classList.toggle('active', index === currentIndex);
        });
        
        // Show swipe hint
        showSwipeHint();
      }
      
      function showSwipeHint() {
        imageContainer.classList.add('show-swipe-hint');
        setTimeout(() => {
          imageContainer.classList.remove('show-swipe-hint');
        }, 2000);
      }
      
      // Update current index when thumbnail is clicked
      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          currentIndex = index;
          console.log('Thumbnail clicked, updating current index to:', currentIndex);
        });
      });
    }
    
    console.log('Savia product gallery initialized');
  });
})();
